import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

import { Views } from '@/enums'

import AppleDeveloperVerification from '../views/AppleDeveloperVerification.vue'
import Checkout from '../views/Checkout.vue'
import ChooseFood from '../views/ChooseFood.vue'
import ContactUsForm from '../views/ContactUsForm.vue'
import FavoriteLocations from '../views/FavoriteLocations.vue'
import FoundationApplicationForm from '../views/FoundationApplicationForm.vue';
import FreeSubsForm from '../views/FreeSubsForm.vue'
import OrderConfirmation from '../views/OrderConfirmation.vue'
import OrderHistory from '../views/OrderHistory.vue';
import OrderSummary from '../views/OrderSummary.vue'
import Product from '../views/Product.vue'
import RewardHistory from '../views/RewardHistory.vue'
import Rewards from '../views/Rewards.vue'
import SelectLocation from '../views/SelectLocation.vue'
import SweepstakesForm from '../views/SweepstakesForm.vue'
import WSAForm from '../views/WSAForm.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/order/:location([0-9a-zA-Z_-]+)/review',
    name: Views.ORDER_SUMMARY,
    component: OrderSummary
  },
  {
    path: '/order/:location([0-9a-zA-Z_-]+)/checkout',
    name: Views.CHECKOUT,
    component: Checkout
  },
  {
    path: '/order/:location([0-9a-zA-Z_-]+)/confirmation',
    name: Views.ORDER_CONFIRMATION,
    component: OrderConfirmation
  },
  {
    path: '/order/:location([0-9a-zA-Z_-]+)/:categorySlug([0-9a-zA-Z_-]+)/:productSlug([0-9a-zA-Z_-]+)/edit/:basketProductId([0-9]+)',
    name: Views.PRODUCT_EDIT,
    component: Product
  },
  {
    path: '/order/:location([0-9a-zA-Z_-]+)/:categorySlug([0-9a-zA-Z_-]+)/:productSlug([0-9a-zA-Z_-]+)',
    name: Views.PRODUCT_ADD,
    component: Product
  },
  {
    path: '/order/:location([0-9a-zA-Z_-]+)/:categorySlug([0-9a-zA-Z_-]+)',
    name: Views.CHOOSE_FOOD_CATEGORY,
    component: ChooseFood
  },
  {
    path: '/order/:location([0-9a-zA-Z_-]+)',
    name: Views.CHOOSE_FOOD,
    component: ChooseFood
  },
  {
    path: '/order',
    name: Views.SELECT_LOCATION,
    component: SelectLocation
  },
  {
    path: '/Account/OrderHistory',
    name: Views.ORDER_HISTORY,
    component: OrderHistory
  },
  {
    path: '/Account/FavoriteLocations',
    name: Views.FAVORITE_LOCATIONS,
    component: FavoriteLocations
  },
  {
    path: '/Account/Rewards',
    name: Views.REWARDS,
    component: Rewards
  },
  {
    path: '/Account/RewardHistory',
    name: Views.REWARD_HISTORY,
    component: RewardHistory
  },
  {
    path: '/contact-us',
    name: Views.CONTACT_US_FORM,
    component: ContactUsForm
  },
  {
    path: '/free-subs',
    name: Views.FREE_SUBS_FORM,
    component: FreeSubsForm
  },
  {
    path: '/free-subs/:freeSubsSlug([0-9a-zA-Z_-]+)',
    name: Views.FREE_SUBS_FORM,
    component: FreeSubsForm
  },
  {
    path: '/sweepstakes/:sweepstakesSlug([0-9a-zA-Z_-]+)',
    name: Views.SWEEPSTAKES_FORM,
    component: SweepstakesForm
  },
  {
    path: '/foundation/foundation-application',
    name: Views.FOUNDATION_APPLICATION_FORM,
    component: FoundationApplicationForm
  },
  {
    path: '/foundation/wisconsin-sports-awards-application',
    name: Views.WSA_FORM,
    component: WSAForm
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
